import { HeaderSearch as HeaderSearchV2 } from '@components/SearchV2/HeaderSearch';
import { usePathname } from 'next/navigation';
import { getWithoutLocale } from 'utils';

export const SearchWrapper = ({
  searchPlaceholder,
}: {
  searchPlaceholder: string;
}) => {
  const pathname = usePathname() || '/';
  const pathnameWithoutLocale = getWithoutLocale(pathname);
  const isOnSearchPage =
    pathnameWithoutLocale === '/search' ||
    pathnameWithoutLocale === '/search-v2';

  return (
    <HeaderSearchV2
      placeholder={searchPlaceholder}
      standalone={!isOnSearchPage}
    />
  );
};
